import Http from "../services/http";
import {
  MERCHANT_RESORTS_LOAD_SUCCESS,
  MERCHANT_COUNTRIES_LOAD_SUCCESS,
  MERCHANT_LIST_LOAD_SUCCESS,
  MERCHANT_LIST_SELECT,
  MERCHANT_LIST_SUCCESS,
  MERCHANT_LIST_SORT,
  MERCHANT_LIST_FILTER,
  MERCHANT_LIST_CHANGE_PAGE,
  MERCHANT_LIST_TOGGLE_FILTERING,
  MERCHANT_INFO_SUCCESS,
  MERCHANT_INFO_UPDATE_SUCCESS,
  MERCHANT_USERS_LOAD_SUCCESS,
  MERCHANT_USERS_DELETE_SUCCESS,
  MERCHANT_USERS_EDIT_MODE,
  MERCHANT_USERS_INPUTS_CHANGE,
  MERCHANT_PARAMETERS_FETCH_SUCCESS,
  MERCHANT_PARAMETERS_DELETE_SUCCESS,
  MERCHANT_PARAMETERS_SAVE_SUCCESS,
  MERCHANT_PARAMETERS_EDIT_MODE,
  MERCHANT_PARAMETERS_INPUTS_CHANGE,
  MERCHANT_E_TICKET_FETCH_SUCCESS,
  MERCHANT_E_TICKET_SAVE_SUCCESS,
  MERCHANT_BILLING_SAVE_SUCCESS,
  TOS_LOAD_SUCCESS,
  TOS_UPLOAD_PROGRESS,
  TOS_UPLOAD_DONE,
  CSV_ERRORS,
  CITIES_LOAD_SUCCESS
} from "../actions";
import {
  snackbar,
  asyncIndicatorShow,
  asyncIndicatorHide
} from "../app/actions";
import { checkPrivileges } from "../auth/privileges";
import auth from "../auth/constants";

import { push } from "react-router-redux";
import { sorted } from "../utils";

export const resortsLoadSuccess = resorts => ({
  type: MERCHANT_RESORTS_LOAD_SUCCESS,
  resorts
});

export const countriesLoadSuccess = countries => ({
  type: MERCHANT_COUNTRIES_LOAD_SUCCESS,
  countries
});

export const loadResorts = () => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/resorts`)
    .then(result => {
      dispatch(resortsLoadSuccess(result));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const loadCountries = () => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/countries`)
    .then(result => {
      dispatch(countriesLoadSuccess(result));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const merchantListLoadSuccess = merchants => ({
  type: MERCHANT_LIST_LOAD_SUCCESS,
  merchants
});

export const loadMerchantList = () => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchantList`)
    .then(result => {
      dispatch(merchantListLoadSuccess(result));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const merchantListToggleFiltering = () => ({
  type: MERCHANT_LIST_TOGGLE_FILTERING
});

export const merchantListSelect = selected => ({
  type: MERCHANT_LIST_SELECT,
  selected
});

export const merchantListSuccess = data => ({
  type: MERCHANT_LIST_SUCCESS,
  data
});

export const merchantListSort = column => ({
  type: MERCHANT_LIST_SORT,
  column
});

export const merchantListChangePage = page => ({
  type: MERCHANT_LIST_CHANGE_PAGE,
  page
});

export const merchantListFilter = (q, kind) => ({
  type: MERCHANT_LIST_FILTER,
  q,
  kind
});

export const merchantCreate = (
  appuserid,
  appaccountid,
  birthcountry,
  birthdate,
  civility,
  companyName,
  email,
  lastname,
  firstname,
  pro,
  siret,
  kind,
  libelle,
  code,
  codeNAF,
  thirdpartyintroduction
) => (dispatch, getState) => {
  const body = {
    appuserid,
    appaccountid,
    birthcountry,
    birthdate,
    civility,
    email,
    lastname,
    firstname,
    pro: pro ? pro : false,
    kind,
    libelle,
    code,
    companyName: pro ? companyName : undefined,
    siret: pro ? siret : undefined,
    codeNAF: pro ? codeNAF : undefined,
    thirdpartyintroduction: pro ? thirdpartyintroduction : 0
  };
  return Http.post(`/merchants/create`, body)
    .then(result => {
      dispatch(asyncIndicatorHide());
      document.location.href = `/configuration/marchands/${code}`;
      //dispatch(push(`/configuration/marchands/${code}`));
    })
    .catch(err => {
      let p = undefined;
      try {
        p = err.json().then(j => Promise.resolve(j.message));
      } catch (e) {
        p = Promise.resolve("Impossible de créer le marchand");
      }
      p.then(message => {
        dispatch(asyncIndicatorHide());
        dispatch(snackbar(message));
      });
    });
};

export const merchantList = () => (dispatch, getState) => {
  dispatch(asyncIndicatorShow());

  const list = getState().merchant.list;
  const sort = sorted(list.sortColumn, list.sortDescending);
  const page = list.page;
  const kind = list.kind;
  const q = list.q;

  return Http.get("/merchants", { page, sort, q, kind })
    .then(result => {
      dispatch(merchantListSuccess(result));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const merchantInfoSuccess = merchant => ({
  type: MERCHANT_INFO_SUCCESS,
  merchant
});

export const merchantInfo = code => dispatch => {
  if (code !== "new") {
    dispatch(asyncIndicatorShow());
    return Http.get(`/merchants/${code}`)
      .then(result => {
        dispatch(merchantInfoSuccess(result));
        dispatch(asyncIndicatorHide());
        return result;
      })
      .catch(err => {
        console.log(err);
        dispatch(asyncIndicatorHide());
      });
  } else {
    dispatch(merchantInfoSuccess({}));
  }
};

export const merchantInfoUpdateSuccess = merchant => ({
  type: MERCHANT_INFO_UPDATE_SUCCESS,
  merchant
});

export const merchantInfoUpdate = (
  code,
  sm_appaccountid,
  sm_appuserid,
  kind,
  libelle,
  mainResort,
  email,
  email_comment_fr,
  email_comment_en,
  notes,
  send_merchant_email,
  merchant_group,
  facet
) => (dispatch, getState) => {
  dispatch(asyncIndicatorShow());
  const oldCode = getState().merchant.detail.code;
  const body = {
    code: code,
    sm_appaccountid: sm_appaccountid === null ? "" : sm_appaccountid,
    sm_appuserid: sm_appuserid === null ? "" : sm_appuserid,
    kind: kind,
    libelle: libelle,
    main_resort: mainResort === null ? undefined : mainResort,
    email: email === null ? "" : email,
    email_comment_fr: email_comment_fr === null ? "" : email_comment_fr,
    email_comment_en: email_comment_en === null ? "" : email_comment_en,
    notes: notes === null ? "" : notes,
    send_merchant_email:
      send_merchant_email !== null &&
      send_merchant_email !== undefined &&
      send_merchant_email === true
        ? 1
        : 0,
    merchant_group:
      merchant_group !== undefined &&
      merchant_group !== null &&
      merchant_group.length > 0
        ? merchant_group
        : undefined,
    facet: facet !== undefined && facet !== null ? facet : 0
  };
  const userPrivileges = getState().app.auth.user.privileges;
  const endpoint = checkPrivileges(userPrivileges, auth.UPDATE_FOR_ESF)
    ? "updateForESF"
    : "updateForMerchant";
  return Http.post(`/merchants/${oldCode}/${endpoint}`, body)
    .then(result => {
      dispatch(asyncIndicatorHide());
      dispatch(merchantInfoSuccess(result));
      if (checkPrivileges(userPrivileges, auth.UPDATE_FOR_ESF)) {
        dispatch(push(`/configuration/marchands/${code}`));
      }
      dispatch(snackbar("La configuration a été sauvegardée"));
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const merchantUsersLoadSuccess = users => ({
  type: MERCHANT_USERS_LOAD_SUCCESS,
  users
});

export const loadUsers = code => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchant/${code}/users`)
    .then(result => {
      dispatch(merchantUsersLoadSuccess(result));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const createUser = ({
  appuserid,
  birthcity,
  birthcountry,
  birthdate,
  civilite,
  email,
  nom,
  prenom
}) => dispatch => {
  dispatch(asyncIndicatorShow());
  const body = {
    appuserid,
    birthcity,
    birthcountry,
    birthdate,
    civilite,
    email,
    nom,
    prenom
  };

  const url = `/users/create`;
  return Http.post(url, body)
    .then(result => {
      dispatch(merchantUsersLoadSuccess(result));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const saveUser = (email, merchant) => dispatch => {
  dispatch(asyncIndicatorShow());
  const body = {
    email: email,
    merchant: merchant
  };
  const url = `/users/save`;
  return Http.post(url, body)
    .then(result => {
      dispatch(merchantUsersLoadSuccess(result));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const merchantUsersDeleteSuccess = users => ({
  type: MERCHANT_USERS_DELETE_SUCCESS,
  users
});

export const deleteUser = (email, merchant) => dispatch => {
  dispatch(asyncIndicatorShow());
  const body = {
    email: email,
    merchant: merchant
  };
  const url = `/users/delete`;
  return Http.post(url, body)
    .then(result => {
      dispatch(merchantUsersDeleteSuccess(result));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const editModeUser = id => ({
  type: MERCHANT_USERS_EDIT_MODE,
  id
});

export const changeUserInputs = (id, email) => ({
  type: MERCHANT_USERS_INPUTS_CHANGE,
  id,
  email
});

export const parametersSuccess = parameters => ({
  type: MERCHANT_PARAMETERS_FETCH_SUCCESS,
  parameters
});

export const loadParameters = code => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${code}/parameters`)
    .then(result => {
      dispatch(parametersSuccess(result));
      dispatch(asyncIndicatorHide());
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const deleteParameterSucccess = id => ({
  type: MERCHANT_PARAMETERS_DELETE_SUCCESS,
  id
});

export const deleteParameter = (id, merchantCode, code) => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.post(`/merchants/${merchantCode}/delete-parameter`, { code })
    .then(result => {
      dispatch(deleteParameterSucccess(id));
      dispatch(asyncIndicatorHide());
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const editMode = id => ({
  type: MERCHANT_PARAMETERS_EDIT_MODE,
  id
});

export const changeParameterInputs = (id, field, value) => ({
  type: MERCHANT_PARAMETERS_INPUTS_CHANGE,
  id,
  field,
  value
});

export const saveParameterSucccess = parameters => ({
  type: MERCHANT_PARAMETERS_SAVE_SUCCESS,
  parameters
});

export const saveParameter = (merchantCode, code, value) => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.post(`/merchants/${merchantCode}/save-parameter`, { code, value })
    .then(parameters => {
      dispatch(saveParameterSucccess(parameters));
      dispatch(asyncIndicatorHide());
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const loadETicketSuccess = status => ({
  type: MERCHANT_E_TICKET_FETCH_SUCCESS,
  status
});

export const loadETicket = code => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${code}/e-ticket`)
    .then(result => {
      dispatch(loadETicketSuccess(result.status));
      dispatch(asyncIndicatorHide());
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const saveETicketSucccess = status => ({
  type: MERCHANT_E_TICKET_SAVE_SUCCESS,
  status
});

export const saveETicket = (merchantCode, status) => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.post(`/merchants/${merchantCode}/save-e-ticket`, { status })
    .then(result => {
      dispatch(saveETicketSucccess(result.status));
      dispatch(asyncIndicatorHide());
      dispatch(snackbar("La configuration e-ticket a été sauvegardée"));
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const merchantBillingUpdateSuccess = (
  name,
  address,
  address2,
  postalCode,
  city,
  country,
  siret,
  identifier,
  codeApe,
  phone,
  fax,
  email,
  contact
) => ({
  type: MERCHANT_BILLING_SAVE_SUCCESS,
  name,
  address,
  address2,
  postalCode,
  city,
  country,
  siret,
  identifier,
  codeApe,
  phone,
  fax,
  email,
  contact
});

export const merchantBillingUpdate = (
  merchantCode,
  name,
  address,
  address2,
  postalCode,
  city,
  country,
  siret,
  identifier,
  codeApe,
  phone,
  fax,
  email,
  contact
) => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.post(`/merchants/${merchantCode}/save-billing`, {
    name,
    address,
    address2,
    postalCode,
    city,
    country,
    siret,
    identifier,
    codeApe,
    phone,
    fax,
    email,
    contact
  })
    .then(data => {
      const dataMessage = typeof data.message === "string" ? data.message : "";
      dispatch(
        merchantBillingUpdateSuccess(
          name,
          address,
          address2,
          postalCode,
          city,
          country,
          siret,
          identifier,
          codeApe,
          phone,
          fax,
          email,
          contact
        )
      );
      dispatch(asyncIndicatorHide());
      dispatch(snackbar(dataMessage));
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const merchantTosLoadSuccess = tos => ({
  type: TOS_LOAD_SUCCESS,
  tos: tos
});

export const loadTos = code => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${code}/tos`)
    .then(result => {
      dispatch(merchantTosLoadSuccess(result));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const uploadProgress = (kind, percentage) => ({
  type: TOS_UPLOAD_PROGRESS,
  kind,
  percentage
});

export const uploadDone = data => ({
  type: TOS_UPLOAD_DONE,
  data
});

export const deleteTos = (code, lang) => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/${code}/tos/delete/${lang}`)
    .then(result => {
      dispatch(merchantTosLoadSuccess(result));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const uploadCSVErrors = errors => ({
  type: CSV_ERRORS,
  errors
});

export const uploadCSVDone = results => dispatch => {
  dispatch(asyncIndicatorHide());
  if (results.errors && results.errors) {
    dispatch(uploadCSVErrors(results.errors));
  } else if (results.merchantsCreated !== undefined) {
    if (results.merchantsCreated > 0) {
      dispatch(snackbar(`${results.merchantsCreated} marchands ont été créés`));
    } else {
      dispatch(snackbar(`Aucun marchand à importer`));
    }
  } else {
    dispatch(
      snackbar("Une erreur est survenue. Veuillez vérifier votre fichier CSV.")
    );
  }
};

export const clearCSVErrors = () => dispatch => {
  dispatch(uploadCSVErrors([]));
};

export const citiesAuthorizedSuccess = ({ cities, resorts }) => ({
  type: CITIES_LOAD_SUCCESS,
  cities,
  resorts
});

export const loadCities = () => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/merchants/import/citiesAuthorized`)
    .then(result => {
      dispatch(citiesAuthorizedSuccess(result));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const addCity = (city, resort) => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.post(`/merchants/import/citiesAuthorized/add`, { city, resort })
    .then(result => {
      dispatch(citiesAuthorizedSuccess(result));
      dispatch(asyncIndicatorHide());
      dispatch(snackbar("L'ajout a été effectué avec succès"));
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};



// WEBPACK FOOTER //
// ./src/merchant/actions.js